import styled from 'styled-components';
import { colors } from '../../assets';

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 30px 23px 30px 60px;
`;

export const Header = styled.div`
	display: flex;
	width: 100%;
	flex-direction: row;
	justify-content: right;
	padding: 0px 60px 30px 0px;
	button {
		:first-of-type {
			margin-right: auto;
		}
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 0px 60px 0px 0px;
	background-color: ${colors.darkGray};
	border-radius: 15px;
	> div {
		margin: 7.5px;
	}
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	min-width: 820px;
	max-height: 95px;
	.selectContractor {
		border-bottom: 1px solid ${colors.primaryBlue};
	}
	:last-child {
		padding-bottom: 0px;
	}

	div {
		margin-right: 15px;
	}
	div:last-child {
		margin-right: 0px;
	}
`;

export const SaveButtonDiv = styled.div`
	display: flex;
	align-content: center;
	justify-content: center;
	padding: 22.5px 5px;
`;
